import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const raceList = async ({ companyCode }) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetRaces}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useRaceQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetRaces],
    queryFn: () => raceList(companyCode),
    refetchOnWindowFocus: false,
    
  });
};
